import React from 'react'
import PropTypes from 'prop-types'
import EventsDisplay from 'pages/pga-coach/bookings/events/event-components/events-display'
import TonalButton from 'components/empty-page-state/tonal-button'
import CelebrationOutlinedIcon from 'components/material-symbol/icons/Celebration'
import AddOutlinedIcon from 'components/material-symbol/icons/Add'
import SectionEmptyState from 'components/section-empty-state'

const tabsMapper = {
  upcoming: 'Upcoming',
  past: 'Past',
}

const EventsDisplaySelection = ({
  events,
  totalEvents,
  history,
  selectedTab,
  advancePagination,
  retreatPagination,
  currentPage,
  lastPage,
}) => {
  return events.length ? (
    <EventsDisplay
      events={events}
      totalEvents={totalEvents}
      advancePagination={advancePagination}
      retreatPagination={retreatPagination}
      currentPage={currentPage}
      lastPage={lastPage}
    />
  ) : (
    <SectionEmptyState
      Icon={CelebrationOutlinedIcon}
      title={`No ${tabsMapper[selectedTab]} Events`}
      caption="Events represent your group coach offerings. Examples include Whiskey and Wedges, Wine and Nine, Night Glow Golf, etc."
      bordered={false}
      action={
        <TonalButton
          startIcon={<AddOutlinedIcon />}
          onClick={() => history.push('/pga-coach/bookings/events/new')}
        >
          Create Event
        </TonalButton>
      }
    />
  )
}
export default EventsDisplaySelection

EventsDisplaySelection.propTypes = {
  events: PropTypes.array,
  totalEvents: PropTypes.number,
  history: PropTypes.object,
  selectedTab: PropTypes.string,
  advancePagination: PropTypes.func,
  retreatPagination: PropTypes.func,
  currentPage: PropTypes.number,
  lastPage: PropTypes.bool,
}
